import { fAlertToast } from "../../Utility/Utilitys";

import { vRdxUserInfo } from "../../Redux/roStore";
import { common_PendingDOAttributes_GETROW } from "../../Server/ApiV2";
// import { fExecuteAPI } from "../../Server/Apis.jsx";

export const sWebPendingDoDetailReportData = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
];
export const sWebPendingDoDetailReportArr = [
  { Uid: "All", Value: "ALL" },
  { Uid: "Is", Value: "Is" },
  { Uid: "From", Value: "From" },
  { Uid: "To", Value: "To" },
  { Uid: "Between", Value: "Between" },
];
export const sWebStampedReportArr = [
  { Uid: "STAMP_PENDING", Value: "Pending" },
  { Uid: "STAMP_COMPLETED", Value: "completed" },
  { Uid: "STAMP_BOTH", Value: "Both" },
];
export const sWebStampedDetailReportArr = [
  { Uid: "STAMP_DTL_PENDING", Value: "Pending" },
  { Uid: "STAMP_DTL_COMPLETED", Value: "completed" },
  { Uid: "STAMP_DTL_BOTH", Value: "Both" },
];
export const sWebBetweenReportArr = [{ Uid: "Between", Value: "Btwn" }];

export const HeadObjectInit = {
  sDate: sWebBetweenReportArr[0].Uid,
  sLocation: "Is",
  sDocNo: "All",
  sParty: "All",
  sCluster: "All",
  sLoadingBay: "All",
  sTransaction: "All",
  sTruck: "All",
  sDriver: "All",
  sStatus: "All",
  sDocType: "All",
  sFromDate: new Date(),
  sToDate: new Date(),
  sDocNo_Input: "",
  sLocationArr: [],
  sLocationPrnt: "",
  sLocationCode: "",
  sLocationName: "",
  sPartyArr: [],
  sPartyPrnt: "",
  sPartyCode: "",
  sPartyName: "",
  sClusterArr: [],
  sClusterPrnt: "",
  sClusterCode: "",
  sClusterName: "",

  sLoadingBayArr: [],
  sLoadingBayPrnt: "",
  sLoadingBayCode: "",
  sLoadingBayName: "",
  sTransactionArr: [],
  sTransactionPrnt: "",
  sTransactionCode: "",
  sTransactionName: "",
  sSalesGroupArr: [],
  sSalesGroupPrnt: "",
  sSalesGroupCode: "",
  sSalesGroupName: "",
  sTruckArr: [],
  sTruckPrnt: "",
  sTruckCode: "",
  sTruckName: "",
  sDriverArr: [],
  sDriverPrnt: "",
  sDriverCode: "",
  sDriverName: "",
  sDocTypeArr: [],
  sDocTypePrnt: "",
  sDocTypeCode: "",
  sDocTypeName: "",
};

export const DetailReporteData = [];
export const AnalysisReporteData = [];
export const ComparisionReporteData = [];

export const GetWmsStockRepotParty = async (setGroupData) => {
  // const CurrentMaingroupArr = await common_PartyListReport_GETROW("");
  // if (CurrentMaingroupArr?.status === 200) {
  //   setGroupData(CurrentMaingroupArr?.data?.ResultSet);
  // }
};

export const GetWMSMISAttributes = async (
  setLoadingBayData,
  setTransactionData,
  setTruckData,
  setDriverData,
  setPartyData,
  setClusterData,
  setDocTypeData,
  setLocationData,
  setStatusData,
  setSalesGroupData,
) => {
  const vRdxUserInfoObj = vRdxUserInfo();
  var userCodeObj = {
    userCd: vRdxUserInfoObj.UserID,
  };
  const vResult = await common_PendingDOAttributes_GETROW(userCodeObj);
  if (vResult?.status === 200) {
    setLoadingBayData(vResult?.data?.ResultSet?.loadingbay);
    setTransactionData(vResult?.data?.ResultSet?.transtype);
    setTruckData(vResult?.data?.ResultSet?.truck);
    setDriverData(vResult?.data?.ResultSet?.driver);
    setPartyData(vResult?.data?.ResultSet?.party);
    setClusterData(vResult?.data?.ResultSet?.cluster);
    setDocTypeData(vResult?.data?.ResultSet?.doctypes);
    setLocationData(vResult?.data?.ResultSet?.loc);
    setStatusData(vResult?.data?.ResultSet?.status);
    setSalesGroupData(vResult?.data?.ResultSet?.salesGroup);
  }
};

export const fValidationHead_Client = (HeadObject) => {
  let iRes = true;

  if (
    HeadObject.sFromDate === "" ||
    HeadObject.sFromDate === null ||
    HeadObject.sFromDate === undefined ||
    HeadObject.sFromDate === "Invalid Date" ||
    HeadObject.sToDate === "" ||
    HeadObject.sToDate === null ||
    HeadObject.sToDate === undefined ||
    HeadObject.sToDate === "Invalid Date"
  ) {
    fAlertToast("FAILED", "Date should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sDocNo.toUpperCase() === "IS" &&
    HeadObject.sDocNo_Input === ""
  ) {
    fAlertToast("FAILED", "Document number should not be empty");

    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sLocation.toUpperCase() === "IS" &&
    HeadObject.sLocationPrnt === ""
  ) {
    fAlertToast("FAILED", "Location should not be empty");

    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sParty.toUpperCase() === "IS" &&
    HeadObject.sPartyPrnt === ""
  ) {
    fAlertToast("FAILED", "Party should not be empty");
    iRes = false;
    return iRes;
  }

  if (
    HeadObject.sLoadingBay.toUpperCase() === "IS" &&
    HeadObject.sLoadingBayPrnt === ""
  ) {
    fAlertToast("FAILED", "LoadingBay should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sTransaction.toUpperCase() === "IS" &&
    HeadObject.sTransactionPrnt === ""
  ) {
    fAlertToast("FAILED", "Transaction should not be empty");
    iRes = false;
    return iRes;
  } 
  if ( 
    HeadObject.sSalesGroupPrnt === ""
  ) {
    fAlertToast("FAILED", "SalesGroup should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sTruck.toUpperCase() === "IS" &&
    HeadObject.sTruckPrnt === ""
  ) {
    fAlertToast("FAILED", "Truck should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sDriver.toUpperCase() === "IS" &&
    HeadObject.sDriverPrnt === ""
  ) {
    fAlertToast("FAILED", "Driver should not be empty");
    iRes = false;
    return iRes;
  }
  if ( 
    HeadObject.sStatus === ""
  ) {
    fAlertToast("FAILED", "Ststus should not be empty");
    iRes = false;
    return iRes;
  }


  if (
    HeadObject.sCluster.toUpperCase() === "IS" &&
    HeadObject.sClusterPrnt === ""
  ) {
    fAlertToast("FAILED", "Cluster should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    HeadObject.sDocType.toUpperCase() === "IS" &&
    HeadObject.sDocTypePrnt === ""
  ) {
    fAlertToast("FAILED", "DocType should not be empty");
    iRes = false;
    return iRes;
  }

  return iRes;
};
export const fValidationDetail_Client = (sBufferObj, HeadObject) => {
  let iRes = true;
  if (
    sBufferObj.sDetailReportRadioBtnName === "" ||
    sBufferObj.sDetailReportRadioBtnName === null ||
    sBufferObj.sDetailReportRadioBtnName === undefined
  ) {
    fAlertToast("FAILED", "DetailReport should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "STAMP_PENDING" &&
    (sBufferObj.sStamped === "" ||
      sBufferObj.sStamped === null ||
      sBufferObj.sStamped === undefined)
  ) {
    fAlertToast("FAILED", "Stamped should not be empty");
    iRes = false;
    return iRes;
  }
  if (
    sBufferObj.sDetailReportRadioBtnName === "STAMP_DTL_PENDING" &&
    (sBufferObj.sStampedDetail === "" ||
      sBufferObj.sStampedDetail === null ||
      sBufferObj.sStampedDetail === undefined)
  ) {
    fAlertToast("FAILED", "Stamped Detail should not be empty");
    iRes = false;
    return iRes;
  }
  return iRes;
};
